class AbstractView extends EventHandler {

  constructor(args) {
    super();

    if (new.target === AbstractView)
      throw "AbstractView is abstract. Do not initialize it directly.";

    this.app = null;

    this.name                = args.name;
    this.branch              = args.branch;
    this.depth               = args.depth;
    this.overlay             = args.overlay;

    this._soapy              = false;
    this._soapyDirection     = null;
    this._element            = null;
    this._elementFilled      = false;
    this._scrollableSelector = null;
    this._previousScroll     = 0;
    this._stuckOnBottom      = true;

    this._initElement();

    this._state              = Utils.sessionStorage('view-state-' + this.name);
  }

  /* METHODS TO OVERRIDE */

  mainTitle() { return "Missing title"; }

  smallTitle() { return "Missing title"; }

  onActive() {}

  chatInput() { return false; }

  initEventListeners() {}

  _htmlBase() { return ""; }


  /* GLOBAL TO ALL VIEWS */

  attachSlaask(app) {
    this.app = app;
  }

  display() {
    Dom.removeClass('widget', this._element, 'slaask-widget-view-hidden');
    this._element.setAttribute('aria-hidden', 'false');
    if (Utils.isIe9)
      this._element.style.display = '';
    if (Utils.isIe10) {
      Utils.uniqueTimeout('view-display-ie10-' + this.name, () => {
        this._element.style.display = '';
      }, Views.getMoverTransitionDuration());
    }

    this._element.style.display = '';
    this._element.style.visibility = 'visible';
    this._element.setAttribute('aria-hidden', 'false');
  }

  hide() {
    Dom.addClass('widget', this._element, 'slaask-widget-view-hidden');
    this._element.setAttribute('aria-hidden', 'true');
    if (Utils.isIe9)
      this._element.style.display = 'none';
    if (Utils.isIe10) {
      Utils.uniqueTimeout('view-display-ie10-' + this.name, () => {
        this._element.style.display = 'none';
      }, Views.getMoverTransitionDuration());
    }

    this._element.setAttribute('aria-hidden', 'true');
    this._element.style.display = 'none';
    this._element.style.visibility = 'hidden';
  }

  setContent(html) {
    this._element.innerHTML = html;
  }

  get element() {
    return this.getElement();
  }


  getElement() {
    if (!this._elementFilled) {
      this._element.innerHTML = this._htmlBase() || "";
      this._elementFilled = true;
    }
    return this._element;
  }

  getScrollableElement() {
    if (this._scrollableSelector == null) return this.element;
    else {
      return this.element.querySelector(this._scrollableSelector);
    }
  }

  scrollToBottom(smooth) {
    this._scrollTo('bottom', smooth);
  }

  scrollToTop(smooth) {
    this._scrollTo('top', smooth);
  }

  scrollBy(amount) {
    Utils.clearTimeout('view-scroll-' + this.name);
    this.getScrollableElement().scrollBy(0, amount);
  }

  tempBlockScroll(time, smooth = true) {
    this._scrollTo('bottom', smooth, time);
  }

  setState(state) {
    this._state = state;
    Utils.sessionStorage('view-state-' + this.name, this._state);
  }

  getState() {
    return this._state;
  }

  syncTitle() {
    let main = this.mainTitle();
    let small = this.smallTitle();
    Dom.mainTitle(main);
    Dom.smallTitle(small);
  }

  isScrollAtBottom() {
    return this._stuckOnBottom;
  }

  updateBranchDepth(branch, depth) {
    this.branch                   = branch;
    this.depth                    = depth;
    Utils.dataSet(this._element, 'branch', branch);
    Utils.dataSet(this._element, 'depth', depth);
    this._element.style.transform = `translateX(${((depth + (branch ? 1 : 0)) * 100)}%`;
  }

  onLeave() {
    this._trigger('leave')
  }

  /**
   * soapy
   * A soapy View will be ignored in the Views tree.
   * When going from View 1 to View 2, if View 2 is soapy,
   * then the View Mover will slip to View 3.
   * @param  {boolean} soapy
   */

  set soapy(soapy) {
    if (Utils.defined(soapy) && soapy != this._soapy) {
      this._soapy = soapy;
      this._trigger('soapy-changed', soapy);
    }
  }

  get soapy() {
    return this._soapy;
  }

  get soapyDirection() {
    return this._soapyDirection;
  }

  /**
   * @param {number} soapyDirection
   *  -1: The view will be soapy only when going backward.
   *  null: The view will always be soapy.
   *  1: The view will be soapy only when going forward.
   */
  setSoapyWithDirection(soapyDirection) {
    this._soapyDirection = soapyDirection;
    this.soapy = true;
  }

  /**
   * @param {number} direction In [-1, null, 1]
   */
  isSoapy(direction) {
    if (!this.soapy) return false;
    else {
      if (!this.soapyDirection) return true;
      else {
        if (direction == this.soapyDirection) return true;
        else return false;
      }
    }
  }

  _initGlobalEventListeners() {
    this.getScrollableElement().addEventListener('scroll', e => {
      let el = e.currentTarget;
      if (el.scrollTop > el.scrollHeight - el.offsetHeight - 100) {
        this._stuckOnBottom = true;
      }
      else {
        let scrollDiff = el.scrollTop - this._previousScroll;
        if (scrollDiff < 0) {
          this._stuckOnBottom = false;
        }
      }
      this._previousScroll = el.scrollTop;
    });

    this.initEventListeners();
  }

  _initElement() {
    this._element           = document.createElement('div');
    this._element.id        = `slaask-widget-view-${this.name}`;
    this._element.className = `slaask-widget-view slaask-widget-view-${this.name}`;
    this.updateBranchDepth(this.branch, this.depth);
  }

  _scrollTo(where, smooth, blockTime = 0) {
    let scrollable = this.getScrollableElement();
    if (smooth && 'scrollBehavior' in Dom.get('widget').document.documentElement.style) {
      Utils.uniqueTimeout('view-scroll-' + this.name, () => {
        let top = where == 'top' ? 0 : (scrollable.scrollHeight - scrollable.offsetHeight);
        scrollable.scroll({
          top: top,
          left: 0,
          behavior: 'smooth'
        });
      }, blockTime || 300, blockTime == 0);
    }
    else {
      Utils.clearTimeout('view-scroll-' + this.name);
      scrollable.scrollTop = where == 'top' ? 0 : scrollable.scrollHeight;
    }
  }

  _onActive() {
    this.onActive();
    this._trigger('active');
  }

}
